<template>
  <Popup :show="show">
    <template #header>
      <h1 class="notice__title">Verificación de actividad</h1>
    </template>
    <template #content>
      <div class="notice__line"></div>
      <img src="../../src/assets/img/alarm.png" alt="alarm" />
      <p class="notice__text">Tu sesión expirará en</p>
      <p class="notice__text">{{ counter }} segundos</p>
    </template>
    <template #footer>
      <Button
        class="notice__button"
        severity="secondary"
        label="Cancelar"
        @click="$emit('logout')"
      />
      <Button
        class="notice__button"
        label="Continuar navegando"
        @click="$emit('continue')"
      />
    </template>
  </Popup>
</template>

<script>
import Button from "primevue/button";

import Popup from "@/components/Popup.vue";

export default {
  components: { Popup, Button },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      counter: 15,
      interval: null,
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.startCountdown();
      } else {
        this.resetCountdown();
      }
    },
  },
  methods: {
    startCountdown() {
      this.interval = setInterval(() => {
        if (this.counter > 0) {
          this.counter--;
        } else {
          clearInterval(this.interval);
          this.counter = 0;
          this.$emit("logout");
        }
      }, 1000);
      return this.counter;
    },
    resetCountdown() {
      this.counter = 15;
      clearInterval(this.interval);
    },
  },
};
</script>
<style>
.popup__container {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: Roboto;
}
.popup__header .notice__title {
  width: 100%;
  text-align: center;
  font-size: 1em;
  padding-block: 1rem;
}
.popup__content {
  text-align: center;
}
.popup__content .notice__line {
  position: fixed;
  top: 41%;
  left: 50%;
  width: 440px;
  transform: translate(-50%, -50%);
  height: 1px;
  background-color: #e6e6e6;
}

@media (max-width: 1367px) {
  .popup__content .notice__line {
    top: 36%;
  }
}
.popup__content .notice__text {
  font-size: 0.8em;
  text-align: center;
}
.popup__footer .notice__button {
  flex-basis: 150px;
}
.popup__footer .notice__button:last-child {
  flex-grow: 1;
}
</style>
